// extracted by mini-css-extract-plugin
export default {"modelMail":"styles_modelMail__FxCvM","buttonSection":"styles_buttonSection__hsFQJ","button":"styles_button__U1tBm","button1":"styles_button1__bY0uh"};